import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpFromBracket,
  faChevronDown,
  faGear,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";

import styles from "./styles/Profile.module.css";
import pic from "../../Assets/profile-pic.webp";
import UserPlaceholder from "../../Assets/user-placeholder.jpeg";
import Card from "../../Components/Card/Card";
import Tab from "../../Components/Tab/Tab";
import cardBg from "../../Assets/card-img.jpg";
import MarketplaceJSON from "../../REALTYSWAPMarketPlace.json";
import axios from "axios";
import { toast } from "react-toastify";
import isEmpty from "../../utils/is-empty";
import Loading from "../../Components/Loading/Loading";
import { useSelector } from "react-redux";

function Profile() {
  const cardData = {
    name: "NFT#1",
    desc: "REALTY SWAP First NFT",
    website: "http://realtyswap.io",
    image: cardBg,
    price: "0.03ETH",
    currentlySelling: "True",
    address: "0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13",
  };
  const [activeCategory, setActiveCategory] = useState("owned");
  const [openDrop, setOpenDrop] = useState(false);
  const [subDrop, setSubDrop] = useState(false);
  const [subDropVal, setSubDropVal] = useState("ETH");
  const [sortDrop, setSortDrop] = useState(false);
  const [sortVal, setSortVal] = useState("Recently Listed");
  const [data, updateData] = useState([]);
  const [dataFetched, updateFetched] = useState(false);
  const [address, updateAddress] = useState("0x");
  const [totalPrice, updateTotalPrice] = useState("0");
  const [isLoading, setIsLoading] = useState(true);
  const [userState, setUserState] = useState({});
  const { address: addressRedux } = useSelector((state) => state.wallet);
  const [isNFTLoading, setIsNFTLoading] = useState(false);
  const [nftCardsData, setNftCardsData] = useState([]);

  async function getNFTData(tokenId) {
    const ethers = require("ethers");
    let sumPrice = 0;
    //After adding your Hardhat network to your metamask, this code will get providers and signers
    // if (!isEmpty(window.ethereum)) {

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const addr = await signer.getAddress();

    //Pull the deployed contract instance
    // let contract = new ethers.Contract(
    //   MarketplaceJSON.address,
    //   MarketplaceJSON.abi,
    //   signer
    // );

    //create an NFT Token
    // let transaction = await contract.getMyNFTs();
    // }

    /*
     * Below function takes the metadata from tokenURI and the data returned by getMyNFTs() contract function
     * and creates an object of information that is to be displayed
     */

    // const items = await Promise.all(
    //   transaction.map(async (i) => {
    //     const tokenURI = await contract.tokenURI(i.tokenId);
    //     let meta = await axios.get(tokenURI);
    //     meta = meta.data;

    //     let price = ethers.utils.formatUnits(i.price.toString(), "ether");
    //     let item = {
    //       price,
    //       tokenId: i.tokenId.toNumber(),
    //       seller: i.seller,
    //       owner: i.owner,
    //       image: meta.image,
    //       name: meta.name,
    //       description: meta.description,
    //     };
    //     sumPrice += Number(price);
    //     return item;
    //   })
    // );

    // updateData(items);
    updateFetched(true);
    updateAddress(addr);
    updateTotalPrice(sumPrice.toPrecision(3));
  }

  const params = useParams();
  const tokenId = params.tokenId;

  useEffect(() => {
    if (addressRedux) {
      if (!dataFetched) getNFTData(tokenId);
    }
  }, [dataFetched, addressRedux]);

  useEffect(() => {
    if (!isEmpty(address) && address !== "0x") {
      setIsLoading(true);

      axios
        .get("/profile/" + address)
        .then((res) => {
          setUserState(res.data);
        })
        .catch((err) => {
          console.log(err);

          toast.error(
            "Uh Oh! Something went wrong while fetching your account"
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [address]);

  useEffect(() => {
    let reqBody = {
      // owner_address: address,
      owner_address: addressRedux,
    };
    if (activeCategory !== "activity") {
      if (activeCategory === "owned") {
        reqBody.filterType = "OWNER_ADDRESS";
      } else if (activeCategory === "created") {
        reqBody.filterType = "OWNER_ADDRESS";
      } else if (activeCategory === "liked") {
        reqBody.filterType = "FAV";
      }
      setIsNFTLoading(true);

      axios
        .post("/assetList", reqBody)
        .then((res) => {
          console.log(res.data.assetList);
          setNftCardsData(res.data.assetList);
        })
        .catch((err) => {
          console.log(err);

          toast.error("Uh Oh! Something went wrong while fetching data");
        })
        .finally(() => {
          setIsNFTLoading(false);
        });
    } else {
      setIsNFTLoading(true);
      axios
        // .get(`profile/activity/${addressRedux}`)
        .get(`profile/activity/123123`)
        .then((res) => {
          setNftCardsData(res.data);
        })
        .catch((err) => {
          toast.error("Uh Oh! Something went wrong while fetching data");
        })
        .finally(() => {
          setIsNFTLoading(false);
        });
    }
  }, [address, activeCategory]);

  return (
    <div className="container">
      {(isNFTLoading || isLoading) && <Loading />}
      <div className={styles.profile}>
        <div
          className={styles.topProfile}
          style={{
            backgroundImage: `url(${userState.bannerImageUrl || cardBg})`,
          }}
        >
          <img src={userState.profileImageUrl || UserPlaceholder} alt="" />
        </div>
        <div className={styles.profileDesc}>
          <div className={styles.desc}>
            <h1>
              {userState.displayName}{" "}
              <span className={styles.joinDate}>
                Joined on: {new Date(userState.joinDate).toLocaleDateString()}
              </span>
            </h1>
            <p>{userState.description}</p>
            <div className={styles.btnDiv}>
              <button className="cta-btn">
                <FontAwesomeIcon icon={faPlus} />
                Follow
              </button>
              <button className="grey-btn">Message</button>
              <button className="grey-btn">
                <FontAwesomeIcon icon={faArrowUpFromBracket} />
              </button>
              <Link to={"/Settings/" + address} className="grey-btn">
                <FontAwesomeIcon icon={faGear} />
              </Link>
            </div>
          </div>
          <div className={styles.followBox}>
            <div className={styles.followRow}>
              <h3>Followers</h3>
              <p>{userState.followers}</p>
            </div>
            <div className={styles.followRow}>
              <h3>Following</h3>
              <p>{userState.following}</p>
            </div>
            <div className={styles.followRow}>
              <h3>Address</h3>
              <p className={styles.address}>{address}</p>
            </div>
          </div>
        </div>
        <div className={styles.nftCategory}>
          <h2
            onClick={() => {
              setActiveCategory("owned");
            }}
            className={`${styles.category} ${
              activeCategory === "owned" && styles.activeCat
            }`}
          >
            Owned <span>{data.length}</span>
          </h2>
          <h2
            onClick={() => {
              setActiveCategory("created");
            }}
            className={`${styles.category} ${
              activeCategory === "created" && styles.activeCat
            }`}
          >
            Created <span>20</span>
          </h2>
          <h2
            onClick={() => {
              setActiveCategory("liked");
            }}
            className={`${styles.category} ${
              activeCategory === "liked" && styles.activeCat
            }`}
          >
            Liked <span>20</span>
          </h2>
          <h2
            onClick={() => {
              setActiveCategory("activity");
            }}
            className={`${styles.category} ${
              activeCategory === "activity" && styles.activeCat
            }`}
          >
            Activity <span>20</span>
          </h2>
        </div>
        <div className={styles.filterBar}>
          <div className={styles.leftFilter}>
            <div className={styles.dropDown}>
              <button
                onClick={() => {
                  setOpenDrop((prev) => {
                    if (prev === "blockchain") {
                      return false;
                    } else {
                      return "blockchain";
                    }
                  });
                }}
              >
                BlockChain <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div
                className={`${styles.mainDrop} ${
                  openDrop === "blockchain" && styles.activeDrop
                }`}
              >
                <ul>
                  <li>Ethereum</li>
                  <li>Flow</li>
                  <li>Solana</li>
                  <li>Solana</li>
                  <li>Solana</li>
                  <li>Solana</li>
                  <li>Solana</li>
                  <li>Solana</li>
                </ul>
                <div className={styles.btnDivDrop}>
                  <button className={`${styles.white} ${styles.disabled}`}>
                    Clear
                  </button>
                  <button className={styles.black}>Apply</button>
                </div>
              </div>
            </div>
            <div className={styles.dropDown}>
              <button
                onClick={() => {
                  setOpenDrop((prev) => {
                    if (prev === "category") {
                      return false;
                    } else {
                      return "category";
                    }
                  });
                }}
              >
                Category <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div
                className={`${styles.mainDrop} ${
                  openDrop === "category" && styles.activeDrop
                }`}
              >
                <ul>
                  <li>All</li>
                  <li>PFP</li>
                  <li>Art</li>
                  <li>Metaverse</li>
                  <li>Domains</li>
                  <li>Photography</li>
                  <li>Music</li>
                  <li>Games</li>
                  <li>Sports</li>
                </ul>
              </div>
            </div>
            <div className={styles.dropDown}>
              <button
                onClick={() => {
                  setOpenDrop((prev) => {
                    if (prev === "sales") {
                      return false;
                    } else {
                      return "sales";
                    }
                  });
                }}
              >
                Sale Type <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div
                className={`${styles.mainDrop} ${
                  openDrop === "sales" && styles.activeDrop
                }`}
              >
                <ul>
                  <li>Buy Now</li>
                  <li>Timed Auction</li>
                  <li>Open for offers</li>
                  <li>Not for sale</li>
                </ul>
                <div className={styles.btnDivDrop}>
                  <button className={`${styles.white} ${styles.disabled}`}>
                    Clear
                  </button>
                  <button className={styles.black}>Apply</button>
                </div>
              </div>
            </div>
            <div className={styles.dropDown}>
              <button
                onClick={() => {
                  setOpenDrop((prev) => {
                    if (prev === "price") {
                      return false;
                    } else {
                      return "price";
                    }
                  });
                }}
              >
                Price range <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div
                className={`${styles.mainDrop} ${styles.smallHeight} ${
                  openDrop === "price" && styles.activeDrop
                }`}
              >
                <div className={styles.subDropDiv}>
                  <button onClick={() => setSubDrop((prev) => !prev)}>
                    {subDropVal} <FontAwesomeIcon icon={faChevronDown} />
                  </button>
                  <div
                    className={`${styles.subDrop} ${
                      subDrop && styles.activeDrop
                    }`}
                  >
                    <p
                      onClick={(e) => {
                        setSubDropVal(e.target.innerText);
                        setSubDrop(false);
                      }}
                    >
                      Eth
                    </p>
                    <p
                      onClick={(e) => {
                        setSubDropVal(e.target.innerText);
                        setSubDrop(false);
                      }}
                    >
                      Flow
                    </p>
                    <p
                      onClick={(e) => {
                        setSubDropVal(e.target.innerText);
                        setSubDrop(false);
                      }}
                    >
                      Fusd
                    </p>
                    <p
                      onClick={(e) => {
                        setSubDropVal(e.target.innerText);
                        setSubDrop(false);
                      }}
                    >
                      XTZ
                    </p>
                  </div>
                </div>
                <div className={styles.inputRowDrop}>
                  <input type="text" placeholder="From" />
                  <input type="text" placeholder="To" />
                </div>
                <div className={styles.btnDivDrop}>
                  <button className={`${styles.white} ${styles.disabled}`}>
                    Clear
                  </button>
                  <button className={styles.black}>Apply</button>
                </div>
              </div>
            </div>
            {/* mobile sort drop down ------------------- */}
            <div className={styles.dropDown}>
              <button onClick={() => setSortDrop((prev) => !prev)}>
                <h6 className={styles.absFilter}>Sort</h6>
                {sortVal} <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div
                className={`${styles.sortDrop} ${
                  sortDrop && styles.activeDrop
                }`}
              >
                <h4>Sort By</h4>
                <h2
                  onClick={(e) => {
                    setSortVal(e.target.innerText);
                    setSortDrop(false);
                  }}
                >
                  Recently Listed
                </h2>
                <h2
                  onClick={(e) => {
                    setSortVal(e.target.innerText);
                    setSortDrop(false);
                  }}
                >
                  Price: Low to High
                </h2>
                <h2
                  onClick={(e) => {
                    setSortVal(e.target.innerText);
                    setSortDrop(false);
                  }}
                >
                  Price: High to Low
                </h2>
                <h2
                  onClick={(e) => {
                    setSortVal(e.target.innerText);
                    setSortDrop(false);
                  }}
                >
                  Auction Ending Soon
                </h2>
              </div>
            </div>
            {/* mobile sort drop down end ------------------- */}
          </div>
          <div className={styles.dropDown}>
            <button onClick={() => setSortDrop((prev) => !prev)}>
              <h6 className={styles.absFilter}>Sort</h6>
              {sortVal} <FontAwesomeIcon icon={faChevronDown} />
            </button>
            <div
              className={`${styles.sortDrop} ${sortDrop && styles.activeDrop}`}
            >
              <h4>Sort By</h4>
              <h2
                onClick={(e) => {
                  setSortVal(e.target.innerText);
                  setSortDrop(false);
                }}
              >
                Recently Listed
              </h2>
              <h2
                onClick={(e) => {
                  setSortVal(e.target.innerText);
                  setSortDrop(false);
                }}
              >
                Price: Low to High
              </h2>
              <h2
                onClick={(e) => {
                  setSortVal(e.target.innerText);
                  setSortDrop(false);
                }}
              >
                Price: High to Low
              </h2>
              <h2
                onClick={(e) => {
                  setSortVal(e.target.innerText);
                  setSortDrop(false);
                }}
              >
                Auction Ending Soon
              </h2>
            </div>
          </div>
        </div>
        {activeCategory === "owned" ||
        activeCategory === "liked" ||
        activeCategory === "created" ? (
          <div className={styles.cardsGrid}>
            {nftCardsData.map((el, idx) => {
              return <Card key={el.id} {...el} />;
            })}
          </div>
        ) : (
          ""
        )}
        {activeCategory === "activity" && (
          <div className={styles.activityGrid}>
            {nftCardsData &&
              nftCardsData.map((el, idx) => {
                return <Tab key={`tab${idx}`} {...el} />;
              })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
